// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/tag_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { CompanyOrEngagement } from "./entity_pb";
import { file_inventory_v1_entity } from "./entity_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/tag_service.proto.
 */
export const file_inventory_v1_tag_service: GenFile = /*@__PURE__*/
  fileDesc("Ch5pbnZlbnRvcnkvdjEvdGFnX3NlcnZpY2UucHJvdG8SDGludmVudG9yeS52MSJaChVBZGRUYWdUb0VudGl0eVJlcXVlc3QSMQoGZW50aXR5GAEgASgLMiEuaW52ZW50b3J5LnYxLkNvbXBhbnlPckVuZ2FnZW1lbnQSDgoGdGFnX2lkGAIgASgJIhgKFkFkZFRhZ1RvRW50aXR5UmVzcG9uc2UiXwoaUmVtb3ZlVGFnRnJvbUVudGl0eVJlcXVlc3QSMQoGZW50aXR5GAEgASgLMiEuaW52ZW50b3J5LnYxLkNvbXBhbnlPckVuZ2FnZW1lbnQSDgoGdGFnX2lkGAIgASgJIh0KG1JlbW92ZVRhZ0Zyb21FbnRpdHlSZXNwb25zZSIgChBDcmVhdGVUYWdSZXF1ZXN0EgwKBG5hbWUYASABKAkiHwoRQ3JlYXRlVGFnUmVzcG9uc2USCgoCaWQYASABKAkiLAoQUmVuYW1lVGFnUmVxdWVzdBIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJIhMKEVJlbmFtZVRhZ1Jlc3BvbnNlIh4KEERlbGV0ZVRhZ1JlcXVlc3QSCgoCaWQYASABKAkiEwoRRGVsZXRlVGFnUmVzcG9uc2UiEQoPTGlzdFRhZ3NSZXF1ZXN0IjMKEExpc3RUYWdzUmVzcG9uc2USHwoEdGFncxgBIAMoCzIRLmludmVudG9yeS52MS5UYWciHwoDVGFnEgoKAmlkGAEgASgJEgwKBG5hbWUYAiABKAkynwQKE1RhZ0ludmVudG9yeVNlcnZpY2USXQoOQWRkVGFnVG9FbnRpdHkSIy5pbnZlbnRvcnkudjEuQWRkVGFnVG9FbnRpdHlSZXF1ZXN0GiQuaW52ZW50b3J5LnYxLkFkZFRhZ1RvRW50aXR5UmVzcG9uc2UiABJsChNSZW1vdmVUYWdGcm9tRW50aXR5EiguaW52ZW50b3J5LnYxLlJlbW92ZVRhZ0Zyb21FbnRpdHlSZXF1ZXN0GikuaW52ZW50b3J5LnYxLlJlbW92ZVRhZ0Zyb21FbnRpdHlSZXNwb25zZSIAEk4KCUNyZWF0ZVRhZxIeLmludmVudG9yeS52MS5DcmVhdGVUYWdSZXF1ZXN0Gh8uaW52ZW50b3J5LnYxLkNyZWF0ZVRhZ1Jlc3BvbnNlIgASTgoJUmVuYW1lVGFnEh4uaW52ZW50b3J5LnYxLlJlbmFtZVRhZ1JlcXVlc3QaHy5pbnZlbnRvcnkudjEuUmVuYW1lVGFnUmVzcG9uc2UiABJOCglEZWxldGVUYWcSHi5pbnZlbnRvcnkudjEuRGVsZXRlVGFnUmVxdWVzdBofLmludmVudG9yeS52MS5EZWxldGVUYWdSZXNwb25zZSIAEksKCExpc3RUYWdzEh0uaW52ZW50b3J5LnYxLkxpc3RUYWdzUmVxdWVzdBoeLmludmVudG9yeS52MS5MaXN0VGFnc1Jlc3BvbnNlIgBCtwEKEGNvbS5pbnZlbnRvcnkudjFCD1RhZ1NlcnZpY2VQcm90b1ABWkFnaXRodWIuY29tL2xlbWEuYWkvbGVtbWF0YS9hcGkvcHJvdG8vZ2VuL2ludmVudG9yeS92MTtpbnZlbnRvcnl2MaICA0lYWKoCDEludmVudG9yeS5WMcoCDEludmVudG9yeVxWMeICGEludmVudG9yeVxWMVxHUEJNZXRhZGF0YeoCDUludmVudG9yeTo6VjFiBnByb3RvMw", [file_inventory_v1_entity]);

/**
 * @generated from message inventory.v1.AddTagToEntityRequest
 */
export type AddTagToEntityRequest = Message<"inventory.v1.AddTagToEntityRequest"> & {
  /**
   * @generated from field: inventory.v1.CompanyOrEngagement entity = 1;
   */
  entity?: CompanyOrEngagement;

  /**
   * @generated from field: string tag_id = 2;
   */
  tagId: string;
};

/**
 * Describes the message inventory.v1.AddTagToEntityRequest.
 * Use `create(AddTagToEntityRequestSchema)` to create a new message.
 */
export const AddTagToEntityRequestSchema: GenMessage<AddTagToEntityRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_tag_service, 0);

/**
 * @generated from message inventory.v1.AddTagToEntityResponse
 */
export type AddTagToEntityResponse = Message<"inventory.v1.AddTagToEntityResponse"> & {
};

/**
 * Describes the message inventory.v1.AddTagToEntityResponse.
 * Use `create(AddTagToEntityResponseSchema)` to create a new message.
 */
export const AddTagToEntityResponseSchema: GenMessage<AddTagToEntityResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_tag_service, 1);

/**
 * @generated from message inventory.v1.RemoveTagFromEntityRequest
 */
export type RemoveTagFromEntityRequest = Message<"inventory.v1.RemoveTagFromEntityRequest"> & {
  /**
   * @generated from field: inventory.v1.CompanyOrEngagement entity = 1;
   */
  entity?: CompanyOrEngagement;

  /**
   * @generated from field: string tag_id = 2;
   */
  tagId: string;
};

/**
 * Describes the message inventory.v1.RemoveTagFromEntityRequest.
 * Use `create(RemoveTagFromEntityRequestSchema)` to create a new message.
 */
export const RemoveTagFromEntityRequestSchema: GenMessage<RemoveTagFromEntityRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_tag_service, 2);

/**
 * @generated from message inventory.v1.RemoveTagFromEntityResponse
 */
export type RemoveTagFromEntityResponse = Message<"inventory.v1.RemoveTagFromEntityResponse"> & {
};

/**
 * Describes the message inventory.v1.RemoveTagFromEntityResponse.
 * Use `create(RemoveTagFromEntityResponseSchema)` to create a new message.
 */
export const RemoveTagFromEntityResponseSchema: GenMessage<RemoveTagFromEntityResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_tag_service, 3);

/**
 * @generated from message inventory.v1.CreateTagRequest
 */
export type CreateTagRequest = Message<"inventory.v1.CreateTagRequest"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message inventory.v1.CreateTagRequest.
 * Use `create(CreateTagRequestSchema)` to create a new message.
 */
export const CreateTagRequestSchema: GenMessage<CreateTagRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_tag_service, 4);

/**
 * @generated from message inventory.v1.CreateTagResponse
 */
export type CreateTagResponse = Message<"inventory.v1.CreateTagResponse"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.CreateTagResponse.
 * Use `create(CreateTagResponseSchema)` to create a new message.
 */
export const CreateTagResponseSchema: GenMessage<CreateTagResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_tag_service, 5);

/**
 * @generated from message inventory.v1.RenameTagRequest
 */
export type RenameTagRequest = Message<"inventory.v1.RenameTagRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message inventory.v1.RenameTagRequest.
 * Use `create(RenameTagRequestSchema)` to create a new message.
 */
export const RenameTagRequestSchema: GenMessage<RenameTagRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_tag_service, 6);

/**
 * @generated from message inventory.v1.RenameTagResponse
 */
export type RenameTagResponse = Message<"inventory.v1.RenameTagResponse"> & {
};

/**
 * Describes the message inventory.v1.RenameTagResponse.
 * Use `create(RenameTagResponseSchema)` to create a new message.
 */
export const RenameTagResponseSchema: GenMessage<RenameTagResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_tag_service, 7);

/**
 * @generated from message inventory.v1.DeleteTagRequest
 */
export type DeleteTagRequest = Message<"inventory.v1.DeleteTagRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message inventory.v1.DeleteTagRequest.
 * Use `create(DeleteTagRequestSchema)` to create a new message.
 */
export const DeleteTagRequestSchema: GenMessage<DeleteTagRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_tag_service, 8);

/**
 * @generated from message inventory.v1.DeleteTagResponse
 */
export type DeleteTagResponse = Message<"inventory.v1.DeleteTagResponse"> & {
};

/**
 * Describes the message inventory.v1.DeleteTagResponse.
 * Use `create(DeleteTagResponseSchema)` to create a new message.
 */
export const DeleteTagResponseSchema: GenMessage<DeleteTagResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_tag_service, 9);

/**
 * @generated from message inventory.v1.ListTagsRequest
 */
export type ListTagsRequest = Message<"inventory.v1.ListTagsRequest"> & {
};

/**
 * Describes the message inventory.v1.ListTagsRequest.
 * Use `create(ListTagsRequestSchema)` to create a new message.
 */
export const ListTagsRequestSchema: GenMessage<ListTagsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_tag_service, 10);

/**
 * @generated from message inventory.v1.ListTagsResponse
 */
export type ListTagsResponse = Message<"inventory.v1.ListTagsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Tag tags = 1;
   */
  tags: Tag[];
};

/**
 * Describes the message inventory.v1.ListTagsResponse.
 * Use `create(ListTagsResponseSchema)` to create a new message.
 */
export const ListTagsResponseSchema: GenMessage<ListTagsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_tag_service, 11);

/**
 * @generated from message inventory.v1.Tag
 */
export type Tag = Message<"inventory.v1.Tag"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message inventory.v1.Tag.
 * Use `create(TagSchema)` to create a new message.
 */
export const TagSchema: GenMessage<Tag> = /*@__PURE__*/
  messageDesc(file_inventory_v1_tag_service, 12);

/**
 * @generated from service inventory.v1.TagInventoryService
 */
export const TagInventoryService: GenService<{
  /**
   * @generated from rpc inventory.v1.TagInventoryService.AddTagToEntity
   */
  addTagToEntity: {
    methodKind: "unary";
    input: typeof AddTagToEntityRequestSchema;
    output: typeof AddTagToEntityResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.TagInventoryService.RemoveTagFromEntity
   */
  removeTagFromEntity: {
    methodKind: "unary";
    input: typeof RemoveTagFromEntityRequestSchema;
    output: typeof RemoveTagFromEntityResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.TagInventoryService.CreateTag
   */
  createTag: {
    methodKind: "unary";
    input: typeof CreateTagRequestSchema;
    output: typeof CreateTagResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.TagInventoryService.RenameTag
   */
  renameTag: {
    methodKind: "unary";
    input: typeof RenameTagRequestSchema;
    output: typeof RenameTagResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.TagInventoryService.DeleteTag
   */
  deleteTag: {
    methodKind: "unary";
    input: typeof DeleteTagRequestSchema;
    output: typeof DeleteTagResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.TagInventoryService.ListTags
   */
  listTags: {
    methodKind: "unary";
    input: typeof ListTagsRequestSchema;
    output: typeof ListTagsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_tag_service, 0);

